var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isAuthenticated ? _c('div', {
    staticClass: "layout"
  }, [_c('nav-bar', {
    attrs: {
      "user": _vm.getUser
    }
  }), _c('div', {
    staticClass: "right-side d-flex flex-column"
  }, [!this.$route.meta.noHeader ? _c('Header', {
    attrs: {
      "user": _vm.getUser
    }
  }) : _vm._e(), _c('div', {
    ref: "innerLayout",
    staticClass: "inner-layout",
    class: {
      'no-header': this.$route.meta.noHeader
    }
  }, [_c('router-view', {
    key: _vm.$route.path
  })], 1)], 1)], 1) : _vm.checkIfRouteIsNavless() ? _c('div', {
    staticClass: "layout-navless d-sm-flex"
  }, [_c('router-view', {
    key: _vm.$route.path,
    staticClass: "w-100"
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }